<section class="animation-outer">
    @if (!authPageService.isMfaTotpSignIn() && !authPageService.isMfaPhoneSignIn()) {
        <form [formGroup]="signInForm" (keydown.enter)="signIn()" autocomplete="on" class="animation-inner" animate.enter="aw-fade-in" animate.leave="aw-fade-out" data-testid="sign-in-form">
            <!--Email-->
            <div class="input-group-wrapper">
                <label for="email-input">{{ "misc.email" | translate }}</label>
                <input class="form-control" type="email" autocomplete="email" formControlName="email" name="email" id="email-input" data-testid="sign-in-form-email-input" />
                <div class="feedback-container">
                    @if (formSubmitted && email?.invalid) {
                        @if (email?.errors?.required) {
                            <div class="error-msg">
                                {{ "misc.email_required" | translate }}
                            </div>
                        }
                    }
                </div>
            </div>

            <!--Password-->
            <div class="input-group-wrapper-feedback">
                <div class="password-label-container">
                    <label for="password-input">{{ "misc.password" | translate }}</label>
                    <button type="button" class="sign-up-link" (click)="openModal(forgotPw)" [disabled]="authPageService.loading()" tabindex="-1" data-testid="sign-in-form-forgot-password-button">
                        {{ "sign-in.forgot_password" | translate }}
                    </button>
                </div>
                <input name="password" id="password-input" class="form-control" type="password" formControlName="password" data-testid="sign-in-form-password-input" />
                <div class="feedback-container">
                    @if (formSubmitted && password?.invalid) {
                        @if (password?.errors?.required) {
                            <div class="error-msg">
                                {{ "misc.password_required" | translate }}
                            </div>
                        }
                        @if (password?.errors?.maxlength) {
                            <div class="error-msg">
                                {{ "misc.password_too_long" | translate }}
                            </div>
                        }
                    }
                </div>
            </div>
        </form>
    }
    <div #recaptchaContainer></div>

    @if (authPageService.isMfaTotpSignIn() || authPageService.isMfaPhoneSignIn()) {
        <div class="animation-inner" animate.enter="aw-fade-in" animate.leave="aw-fade-out">
            <div class="mfa">
                @if (authPageService.isMfaTotpSignIn()) {
                    <p class="mfa-please">{{ "account.mfa.enter_ot_code" | translate }}</p>
                    <app-aw-otp-input (otpComplete)="catchOtpEvent($event)" [dataTestId]="'sign-in-mfa-totp-otp-input'" />
                    <p class="mfa-desc">{{ "account.mfa.open_mfa" | translate }}</p>
                    <div class="mfa-sms">
                        <p>
                            <u class="mfa-sms-btn" (click)="sendPhoneMfa()" data-testid="sign-in-mfa-verify-with-sms-button">{{ "account.mfa.verify_w_sms" | translate }}</u>
                        </p>
                    </div>
                } @else {
                    <p class="mfa-please">{{ "account.mfa.enter_sms_code" | translate }}</p>
                    <app-aw-otp-input [isPhone]="true" (otpComplete)="catchOtpEvent($event, true)" [dataTestId]="'sign-in-mfa-phone-otp-input'" />
                    <p class="mfa-desc">
                        {{ "account.mfa.sign_in_sent_1" | translate }}
                        <strong>{{ "account.mfa.sign_in_sent_2" | translate }} {{ authPageService.phoneLast4Digits() }}</strong>
                    </p>

                    <div class="mfa-sms">
                        <img src="assets/icons/check-circle.svg" alt="check mark" />
                        <p>
                            {{ "account.mfa.sent" | translate }}
                            <u class="mfa-sms-btn" (click)="sendPhoneMfa()" data-testid="sign-in-mfa-resend-sms-button">{{ "account.mfa.send_again" | translate }}</u>
                        </p>
                    </div>
                }
            </div>
        </div>
    }
</section>

<ng-template #forgotPw>
    <app-aw-modal>
        <h4 modal-title class="modal-title">{{ "sign-in.forgot_password" | translate }}</h4>
        <ng-container modal-body>
            <div class="input-group-wrapper">
                <label for="forgot-password">{{ "misc.email" | translate }}</label>
                <input id="forgot-password" name="forgot-email" class="form-control" value="{{ signInForm.get('email').value }}" type="email" data-testid="forgot-password-modal-email-input" />
            </div>
        </ng-container>
        <ng-container modal-footer>
            <app-aw-button color="secondary" size="large" [loading]="resetPWLoading()" (clickEmitter)="resetPassword()" dataTestId="forgot-password-modal-send-button">
                <span button-content>{{ "sign-in.send_email" | translate }}</span>
            </app-aw-button>
        </ng-container>
    </app-aw-modal>
</ng-template>
